import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import Footer from "../components/Footer";
import HomeSections from "../components/HomeSections";
import { SiteLogo } from "../components/SiteLogo";
import { LangSwitcher } from "../components/LangSwitcher";
import { t } from "../i18n";
import { GoogleSignInButton } from "../components/GoogleSignInButton";

export default function Landing() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [secoes, setSecoes] = useState(null);

  useEffect(() => {
    if (!loading && user) navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const e = p.get("auth_error");
    if (e) {
      toast.error(e === "denied"
        ? t("Login cancelado: você precisa autorizar o acesso com o Google para entrar.")
        : t("Não foi possível entrar com o Google. Tente novamente."));
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, []);

  useEffect(() => {
    api.get("/pages/home").then(({ data }) => setSecoes(data.secoes || [])).catch(() => setSecoes([]));
  }, []);

  const login = async () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    try {
      const { data } = await api.get("/auth/google/start", { params: { origin: window.location.origin } });
      window.location.href = data.url;
    } catch {
      toast.error(t("Não foi possível iniciar o login com o Google. Tente novamente."));
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground overflow-x-hidden flex flex-col">
      <header className="h-16 border-b border-border/60 flex items-center justify-between px-6 md:px-10 sticky top-0 z-40 bg-background/80 backdrop-blur">
        <div className="flex items-center" data-testid="brand-logo">
          <SiteLogo className="h-9 w-auto" />
        </div>
        <div className="flex items-center gap-3">
          <LangSwitcher />
          <GoogleSignInButton data-testid="header-login-btn" onClick={login}>
            {t("Entrar com Google")}
          </GoogleSignInButton>
        </div>
      </header>

      <main className="flex-1">
        {secoes === null ? (
          <div className="min-h-[60vh] flex items-center justify-center"><div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" /></div>
        ) : (
          <HomeSections secoes={secoes} onLogin={login} />
        )}
      </main>
      <Footer />
    </div>
  );
}
